import APIClient from "~/services/APIClient"

export default function(_ctx, inject) {
  const api = new APIClient()
  inject("api", api)
}
